module.exports = __webpack_public_path__ + "img/blue1.bb1e3b6d.jpg";